import { useTranslation } from "react-i18next";
const SubmitButton = (props) => {
    const { t } = useTranslation()

    return (
        <div className='d-flex justify-content-center'>
            <button type="submit" class="btn btn-primary btn-lg">{t("create")}</button>
        </div>

    );
};

export default SubmitButton;